import * as $ from "jquery"
import { Swiper, SwiperOptions, Navigation} from 'swiper';
import 'swiper/swiper-bundle.css';
import { initLazy } from '../../utility/lazyload';

const init = ()=> {
    
    let mediaSliderClass = 'js-media-slider';
    
    if($(mediaSliderClass).length > 0){
        console.log($(mediaSliderClass).length);
    }

    const swiperOptions = (next: string,prev: string, slideNumber: number = 1) => {
        Swiper.use([Navigation])
        const swiperParams: SwiperOptions = {
            spaceBetween: 4,
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            breakpoints: {
                768: {
                    slidesPerView: 1
                },
                1024: {
                    slidesPerView: slideNumber
                }
            }
        };
        return swiperParams
    }

    const createSlider = () => {

        $(`.${mediaSliderClass}`).each((i,e) => {

            const rightArrow = $(e).find(`.${mediaSliderClass}--right`);
            const leftArrow = $(e).find(`.${mediaSliderClass}--left`);
            const desc = $(e).find(`.media-slider__desc`);
            const slideNumber = $(e).attr('data-slide-number') ? parseInt($(e).attr('data-slide-number')) : 1;
            

            $(e).addClass(`${mediaSliderClass}-${i}`);
            rightArrow.addClass(`${mediaSliderClass}--right-${i}`);
            leftArrow.addClass(`${mediaSliderClass}--left-${i}`);
            desc.text($(e).find(`.media-slider__slide-desc`).eq(0).text());

            const swiper = new Swiper(`.${mediaSliderClass}-${i}`, swiperOptions(`.${mediaSliderClass}--right-${i}`,`.${mediaSliderClass}--left-${i}`, slideNumber));

            swiper.on('slideChange', () => {
                setTimeout(()=>{ 
                    const currentDesc = $(e).find(`.swiper-slide-active`).find(`.media-slider__slide-desc`);
                    desc.html(currentDesc.text())
                }, 10);
                
            })
        })
        
    }
    setTimeout(()=>{ 
        createSlider();
        initLazy.init();
    }, 100);
	
}




export const mediaSlider = {
	init: init
};